module.exports = __webpack_public_path__ + "img/oufu_85x105x10b.prt.1951b097.jpg";